import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import KalkulatorView from '../views/KalkulatorView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/kalkulator'
  },
  {
    path: '/kalkulator/',
    component: KalkulatorView,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
